<template>
  <div class="create">
    <info-panel :padding="24">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="90px"
      >
        <el-row :gutter="20">
          <el-col :span="18">
            <el-form-item
              label="考试须知"
              prop="examPurchaseNotice"
            >
              <!-- <el-input
                v-model="createForm.examPurchaseNotice"
                type="textarea"
              /> -->
              <editor :html.sync="createForm.examPurchaseNotice" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </info-panel>
    <el-row
      :gutter="20"
      class="submit"
    >
      <el-col class="btns">
        <el-button @click="cancel">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="submit"
        >
          保存
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import axClient from '@/services';
import infoPanel from '@/components/common/infoPanel.vue';
import Editor from '@/components/common/editor.vue';

export default {
  name: 'AgencyEdit',
  components: {
    infoPanel,
    Editor,
  },
  data() {
    return {
      createForm: {
        examPurchaseNotice: '',
      },
      creatRules: {
        examPurchaseNotice: [
          { required: false, message: '请输入考试须知', trigger: 'blur' },
        ],
      },
      isEditType: !!this.$route.params.id,
    };
  },
  mounted() {
    this.isEdit();
  },
  methods: {
    // 取消
    cancel() {
      window.history.back();
    },
    // 提交
    async submit() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const data = await axClient.config.updateExamPurchaseNotice(this.createForm);
          if (data) {
            this.$message.success('编辑考试须知成功');
            this.$router.push({ name: 'ConfigExam' });
          }
        }
      });
    },
    // 是否编辑信息
    async isEdit() {
      const { examPurchaseNotice } = await axClient.config.getExamPurchaseNotice();
      this.createForm = {
        examPurchaseNotice,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.submit {
  margin-top: 20px;
  text-align: center;
}
</style>